import React from 'react'

export const men = (props) => {

    console.log(props)
    return(
        <div>men Page</div>
    )


}